import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type ExploreTradingPhotoCardsParams = NonNullable<
  paths['/api/v1/trading_photo_cards/explore']['get']['parameters']['query']
>;
export type ExploreTradingPhotoCardsResponse =
  paths['/api/v1/trading_photo_cards/explore']['get']['responses'][200]['content']['application/json'];

export type GetTradingPhotoCardResponse =
  paths['/api/v1/trading_photo_cards/{id}']['get']['responses'][200]['content']['application/json'];

export async function exploreTradingPhotoCards(
  params?: ExploreTradingPhotoCardsParams
): Promise<ExploreTradingPhotoCardsResponse> {
  const { data, error } = await client.GET('/api/v1/trading_photo_cards/explore', {
    params: { query: params },
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when exploring trading photo cards');
  return data;
}

export async function getTradingPhotoCard(id: string): Promise<GetTradingPhotoCardResponse> {
  const { data, error } = await client.GET('/api/v1/trading_photo_cards/{id}', {
    params: { path: { id } },
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when getting trading photo card');
  return data;
}
